import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import GroupedValidator from '../Validators/GroupedValidator';
import { ShapeCategory } from '@/types/shapeCategories';

export default class SlopedRightRectangleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'height',
			'width_top',
			'width_bottom',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {
		return {
			height: maximum_rectangle.get_width(),
			width_top: maximum_rectangle.get_longest_side(),
			width_bottom: maximum_rectangle.get_longest_side(),
		};
	}

	get_labels(): Record<string, string> {
		const { height, width_top, width_bottom } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			height,
			width_top,
			width_bottom,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		const { at_least_one } = window.measurementSelectorVariables.i18n.validators.dimensions;

		return {
			width_top: [ MaximumDecimalPoints, MaximumValue ],
			width_bottom: [ MaximumDecimalPoints, MaximumValue ],
			height: [ MaximumDecimalPoints, MaximumValue ],
			grouped: [
				new GroupedValidator(
					MinimumValue,
					[ 'width_top', 'width_bottom', 'height' ],
					'sloped-right-rectangle_minimum',
					at_least_one.min
				)
			]
		};
	}

	get_category(): ShapeCategory {
		return 'straight';
	}
}
